import { render } from "./site-search-main.vue?vue&type=template&id=3c23d36a"
import script from "./site-search-main.vue?vue&type=script&lang=js"
export * from "./site-search-main.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__